export default __webpack_public_path__ + "static/media/down.26ef1dea.svg";